"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _orm = _interopRequireDefault(require("./orm"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _default() {
  var initialState = _orm["default"].getEmptyState();

  var session = _orm["default"].mutableSession(initialState);

  var Menu = session.Menu,
      BannerGroup = session.BannerGroup,
      Banner = session.Banner;
  var menu1 = Menu.create({
    collapsed: true,
    collapsedRegions: ['right', 'bottom']
  });
  var bannerGroup1 = BannerGroup.create({
    menuId: menu1.getId(),
    region: 'right',
    collapsed: true
  });
  Banner.create({
    bannerGroupId: bannerGroup1.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/500x300',
    alt: '500x300'
  });
  Banner.create({
    bannerGroupId: bannerGroup1.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/500x300',
    alt: '500x300'
  });
  Banner.create({
    bannerGroupId: bannerGroup1.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/500x300',
    alt: '500x300'
  });
  var bannerGroup2 = BannerGroup.create({
    menuId: menu1.getId(),
    region: 'bottom',
    collapsed: true
  });
  Banner.create({
    bannerGroupId: bannerGroup2.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/300x200',
    alt: '300x200'
  });
  Banner.create({
    bannerGroupId: bannerGroup2.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/300x200',
    alt: '300x200'
  });
  Banner.create({
    bannerGroupId: bannerGroup2.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/300x200',
    alt: '300x200'
  });
  Banner.create({
    bannerGroupId: bannerGroup2.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/300x200',
    alt: '300x200'
  });
  var bannerGroup3 = BannerGroup.create({
    menuId: menu1.getId(),
    region: 'bottom',
    collapsed: true
  });
  Banner.create({
    bannerGroupId: bannerGroup3.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/300x200',
    alt: '300x200'
  });
  Banner.create({
    bannerGroupId: bannerGroup3.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/300x200',
    alt: '300x200'
  });
  Banner.create({
    bannerGroupId: bannerGroup3.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/300x200',
    alt: '300x200'
  });
  Banner.create({
    bannerGroupId: bannerGroup3.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/300x200',
    alt: '300x200'
  });
  var menu2 = Menu.create({
    collapsed: true,
    collapsedRegions: ['right', 'bottom']
  });
  var bannerGroup4 = BannerGroup.create({
    menuId: menu2.getId(),
    region: 'right',
    collapsed: true
  });
  Banner.create({
    bannerGroupId: bannerGroup4.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/500x300',
    alt: '500x300'
  });
  Banner.create({
    bannerGroupId: bannerGroup4.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/500x300',
    alt: '500x300'
  });
  var bannerGroup5 = BannerGroup.create({
    menuId: menu2.getId(),
    region: 'bottom',
    collapsed: true
  });
  Banner.create({
    bannerGroupId: bannerGroup5.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/400x200',
    alt: '400x200'
  });
  Banner.create({
    bannerGroupId: bannerGroup5.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/400x200',
    alt: '400x200'
  });
  Banner.create({
    bannerGroupId: bannerGroup5.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/400x200',
    alt: '400x200'
  });
  var bannerGroup6 = BannerGroup.create({
    menuId: menu2.getId(),
    region: 'bottom',
    collapsed: true
  });
  Banner.create({
    bannerGroupId: bannerGroup6.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/300x200',
    alt: '300x200'
  });
  Banner.create({
    bannerGroupId: bannerGroup6.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/300x200',
    alt: '300x200'
  });
  Banner.create({
    bannerGroupId: bannerGroup6.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/300x200',
    alt: '300x200'
  });
  Banner.create({
    bannerGroupId: bannerGroup6.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/300x200',
    alt: '300x200'
  });
  var menu3 = Menu.create({
    collapsed: true,
    collapsedRegions: ['right', 'bottom']
  });
  var bannerGroup7 = BannerGroup.create({
    menuId: menu3.getId(),
    region: 'right',
    collapsed: true
  });
  Banner.create({
    bannerGroupId: bannerGroup7.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/500x300',
    alt: '500x300'
  });
  var bannerGroup8 = BannerGroup.create({
    menuId: menu3.getId(),
    region: 'bottom',
    collapsed: true
  });
  Banner.create({
    bannerGroupId: bannerGroup8.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/300x300',
    alt: '300x300'
  });
  Banner.create({
    bannerGroupId: bannerGroup8.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/300x300',
    alt: '300x300'
  });
  Banner.create({
    bannerGroupId: bannerGroup8.getId(),
    collapsed: true,
    link: '#',
    img: '//via.placeholder.com/300x300',
    alt: '300x300'
  });
  initialState.collapsed = false;
  return initialState;
}